import * as stylex from "@stylexjs/stylex";
import { Undo2 } from "lucide-react";
import { copy } from "@/copy";
import type { Tag } from "@/domain/schemas";
import type { TagFilter } from "@/domain/tags";
import "@/theme/tokens.stylex";
import { colors } from "@/theme/tokens.stylex";
import { Button } from "@/ui/Button";
import { IconButton } from "@/ui/IconButton";
import { WhoFilter } from "@/ui/WhoFilter";
type CalendarToolbarProps = {
  tags: readonly Tag[];
  filter: ReadonlySet<string>;
  small: boolean;
  onFilter: (filter: TagFilter) => void;
  onToday?: () => void;
};
const _temp = {
  kmuXW: "x2lah0s",
  kWkggS: "x5r8ks9",
  "$$css": true
};
const styles = {
  soft: (height: number) => [_temp, {
    kAzted: height != null ? "x82snj4" : height,
    $$css: true
  }, {
    "--x-minHeight": (val => typeof val === "number" ? val + "px" : val != null ? val : undefined)(height)
  }],
  today: {
    kZCmMZ: "xwn43p0",
    kwRFfy: "x1o5r3ls",
    $$css: true
  },
  goToday: {
    kzqmXN: "x187nhsf",
    kZKoxP: "xn3w4p2",
    $$css: true
  }
};
const TODAY_HEIGHT = 48;
const STACK_MAX = {
  small: 4,
  large: 8
} as const;
const SMALL_STACK_BESIDE_TODAY = 3;
export function CalendarToolbar({
  tags,
  filter,
  small,
  onFilter,
  onToday
}: CalendarToolbarProps) {
  const size = small ? "small" : "large";
  const max = small && onToday ? SMALL_STACK_BESIDE_TODAY : STACK_MAX[size];
  return <div {...{
    0: {
      className: "x78zum5 x1a02dak x6s0dn4 x1qughib xp1r0qw x40hh3e"
    },
    1: {
      className: "x78zum5 x6s0dn4 x1qughib xp1r0qw xozqiw3 xfex06f"
    }
  }[!!small << 0]}>
      <div className="x78zum5 x6s0dn4 x167g77z xeuugli x1iyjqo2 xs83m0k xdl72j9">
        <WhoFilter tags={tags} selected={filter} size={size} max={max} labels={copy.personFilter} onChange={onFilter} />
      </div>
      {onToday && <div className="x78zum5 x1a02dak x6s0dn4 xp1r0qw x40hh3e x2lah0s xeuugli">
          {small ? <IconButton icon={Undo2} label={copy.calendar.goToday} onClick={onToday} xstyle={styles.goToday} /> : <Button variant="ghost" icon={Undo2} onClick={onToday} xstyle={[styles.soft(TODAY_HEIGHT), styles.today]}>
              {copy.calendar.today}
            </Button>}
        </div>}
    </div>;
}